<template>
  <v-container>
    <v-row>
      <v-col col="4">
        <h4 class="title">Company</h4>
        <p>{{ client.company }}</p>
      </v-col>

      <v-col col="4">
        <h4 class="title">Created At</h4>
        <p>{{ client.created_at | date }}</p>
      </v-col>
      <v-col col="4">
        <h4 class="title">Email</h4>
        <p class="body-1">{{ client.email }}</p>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  props: {
    client: {
      required: true,
    },
  },
};
</script>
